import type { PortalReseller } from '@central/api';
import { Card, color } from '@central/ui';

/**
 * Who gives the customer support when a reseller does: its name, logo and
 * how to reach it. Nothing renders for a customer Rethink supports directly.
 */
export function SupportedBy({ reseller }: { reseller?: PortalReseller }) {
  if (!reseller) return null;
  const link = { color: color.link };
  return (
    <Card>
      <section
        aria-label="Your support partner"
        style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}
      >
        {reseller.logoUrl && (
          <img
            src={reseller.logoUrl}
            alt={`${reseller.name} logo`}
            width={48}
            height={48}
            style={{ objectFit: 'contain', flexShrink: 0 }}
          />
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 }}>
          <strong>Supported by {reseller.name}</strong>
          <span style={{ fontSize: 13, color: color.textMuted }}>
            Your GoATMS partner answers your messages first and brings in Rethink when needed.
          </span>
          <span
            style={{
              display: 'flex',
              gap: 16,
              flexWrap: 'wrap',
              fontSize: 14,
              overflowWrap: 'anywhere',
            }}
          >
            {reseller.supportEmail && (
              <a href={`mailto:${reseller.supportEmail}`} style={link}>
                {reseller.supportEmail}
              </a>
            )}
            {reseller.supportPhone && (
              <a href={`tel:${reseller.supportPhone.replace(/[^\d+]/g, '')}`} style={link}>
                {reseller.supportPhone}
              </a>
            )}
            {reseller.website && (
              <a href={reseller.website} target="_blank" rel="noopener noreferrer" style={link}>
                {reseller.website.replace(/^https:\/\//, '')}
              </a>
            )}
          </span>
        </div>
      </section>
    </Card>
  );
}
